import React from 'react';
import {WebformInput, WebformTextarea} from './';
import {useWizardMaxPage, useWizardProgress} from '../../contexts/useWizardProgress';
import {
  getWizardPageIndex,
  incrementWizardPageIndex, resetWizardPageIndex,
} from '../../components/Paragraphs/SourceRequest';

export default function WizardPage({element, error}): React.JSX.Element {
  const {currentStep, setCurrentStep} = useWizardProgress();
  const maxPage = useWizardMaxPage();

  const wizardPageIndex = getWizardPageIndex();
  if (wizardPageIndex > maxPage) return <></>;

  incrementWizardPageIndex();

  const getAttributeValue = (element, attribute: string): string => {
    for (let i = 0; i < element.attributes.length; i++) {
      if (element.attributes[i].name == attribute) {
        return element.attributes[i].value;
      }
    }

    return '';
  };

  const renderElement = (element, idx): React.JSX.Element => {
    switch (element.type) {
      case 'textfield':
        return (
          <WebformInput key={idx} element={{...element, type: 'text'}}/>
        );
      case 'textarea':
        return <WebformTextarea key={idx} element={element}/>;
      case 'tel':
      case 'number':
      case 'email':
      case 'hidden':
        return <WebformInput key={idx} element={element}/>;
      case 'fieldset':
        return (
          <div key={idx} className="vl-form-col--1-1">
            <p className="vl-u-text--bold vl-u-spacer--small vl-u-spacer-top--small">
              {getAttributeValue(element, '#title')}
            </p>

            {element.elements.map(renderElement)}
          </div>
        );
      default:
        return <></>;
    }
  };

  const pageTitle = getAttributeValue(element, '#title');
  const previousLabel = getAttributeValue(element, '#prev_button_label');
  const nextLabel = getAttributeValue(element, '#next_button_label');

  const validatewizardPage = () => {
    let hasValidationErrors = false;
    const elementsToValidate = document
      .querySelectorAll(`#${element.name} input, #${element.name} textarea`);

    elementsToValidate.forEach((element) => {
      const messageContainer = document.querySelector(`[data-vl-error-id="${element.name}-error"]`);
      const inputErrorClass = element.dataset.vlErrorClass;

      element.classList.remove(inputErrorClass);
      messageContainer.innerHTML = '';

      if (!element.checkValidity()) {
        element.classList.add(inputErrorClass);
        messageContainer.innerHTML = element.dataset.vlErrorMessage;

        hasValidationErrors = true;
      }
    });

    return !hasValidationErrors;
  };

  const handlePageNavigation = (event: any) => {
    event.preventDefault();

    if (!event.target.dataset.skipValidation) {
      if (!validatewizardPage()) {
        return;
      }
    }

    const target = event.target.attributes['data-wizard-target'].value;
    resetWizardPageIndex();
    setCurrentStep(+target);
  };

  const validateAndSubmit = (event: any) => {
    if (!validatewizardPage()) {
      return;
    }
  };

  return (
    <li
      className={'vl-step ' + (currentStep == wizardPageIndex ? 'vl-step--highlighted' : '')}
      id={element.name}
    >
      <div className="vl-step__container">
        <div className="vl-step__icon">
          <span className="vl-u-visually-hidden">Stap </span>
          {wizardPageIndex}
        </div>
        <div className="vl-step__wrapper">
          <div className="vl-step__header">
            <div className="vl-step__header__titles">
              <h3 className="vl-step__title">{pageTitle}</h3>
            </div>
          </div>

          <div
            className="vl-step__content-wrapper vl-u-bg-alt"
            style={{
              padding: '2.4rem',
              display: (currentStep == wizardPageIndex) ? 'block' : 'none',
              visibility: (currentStep == wizardPageIndex) ? 'visible' : 'hidden',
            }}>
            <div className="vl-form-grid vl-form-grid--is-stacked">
              {element.elements.map(renderElement)}
            </div>

            <div className="vl-action-group vl-u-spacer-top--medium">
              {previousLabel ? (
                <button
                  type="button"
                  className="vl-button vl-button--secondary vl-button--narrow"
                  vl-button=""
                  data-wizard-target={wizardPageIndex - 1}
                  onClick={handlePageNavigation}
                  data-skip-validation="true"
                >{previousLabel}</button>
              ) : (
                <></>
              )}

              {element.elements[element.elements.length - 1].type == 'webform_actions' ? (
                <button
                  type="submit"
                  className="vl-button vl-button--narrow"
                  vl-button=""
                  onClick={validateAndSubmit}
                >Aanvragen</button>
              ) : <></>}

              {nextLabel ? (
                <button
                  type="button"
                  className="vl-button vl-button--narrow"
                  vl-button=""
                  data-wizard-target={wizardPageIndex + 1}
                  onClick={handlePageNavigation}
                >{nextLabel}</button>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      </div>
    </li>
  );
}
